import React, {Component, useContext, useEffect, useState} from "react";
import Menu from "./Menu";
import {Helmet} from "react-helmet";
import {Route, Switch} from 'react-router';
import {Link} from 'react-router-dom';
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';

//importing the modules/pages
import FullScreenPhotos from '../modules/FullScreenPhotos';
import Omschrijving from '../modules/Omschrijving';
import Kenmerken from '../modules/Kenmerken';
import Custom from '../modules/Custom';
import Documentatie from '../modules/Documentatie';
import InDeBuurt from '../modules/InDeBuurt';
import Zonnegrens from '../modules/Zonnegrens';
import Contact from '../modules/Contact';
import FotoGalerij from '../modules/FotoGalerij';
import PdfViewer from '../modules/PdfViewer';
import FullScreenVideo from '../modules/FullScreenVideo';
import FloorPlans from '../modules/FloorPlans';
import Protected from '../modules/Protected';
import Photos360 from '../modules/Photos360';
import Photos360Legacy from '../modules/Photos360Legacy';
import ZonnePanelenInfo from '../modules/ZonnePanelenInfo';
import Brochure from '../modules/Brochure';
import BrochureHtml from '../modules/BrochureHtml';
import FullScreenStreetview from '../modules/FullScreenStreetview';
import SiteBaseForm from "./SiteBaseForm";
import WoningWaarde from '../modules/WoningWaarde';
import CheckJePlek from '../modules/CheckJePlek';
import {withRouter} from 'react-router-dom';
import axios from "axios";
import {getMenuFontSize, isEmpty, slugify} from '../inc/Helpers';
import * as Sentry from '@sentry/browser';
import {sentry_url, RELEASE} from "../inc/sentry-config";
import {UncontrolledButtonDropdown, DropdownMenu, DropdownItem, DropdownToggle} from 'reactstrap';
import LangContext from "../providers/LangContext";
import HorizontalMenu from "./light/HorizontalMenu";
import BiddingModalNL from "./biddingforms/BiddingModalNL";
import BiddingModalBE from "./biddingforms/BiddingModalBE";
import {post} from "../inc/Http";
import CadastralMapPage from "../modules/CadastralMapPage";

const BiddingForms = {
    nl: BiddingModalNL,
    be: BiddingModalBE,
}

Sentry.init({
    beforeSend(event, hint) {
        if (hint.originalException === "Timeout") return null;
        return event;
    },
    dsn: sentry_url,
    release: RELEASE,
});

const Modules = {
    Omschrijving: Omschrijving,
    Kenmerken: Kenmerken,
    Custom: Custom,
    Documentatie: Documentatie,
    InDeBuurt: InDeBuurt,
    Zonnegrens: Zonnegrens,
    Contact: Contact,
    FotoGalerij: FotoGalerij,
    FullScreenPhotos: FullScreenPhotos,
    PdfViewer: PdfViewer,
    FullScreenVideo: FullScreenVideo,
    Protected: Protected,
    Photos360: Photos360,
    Photos360Legacy: Photos360Legacy,
    ZonnePanelenInfo: ZonnePanelenInfo,
    Brochure: Brochure,
    BrochureHtml: BrochureHtml,
    FullScreenStreetview: FullScreenStreetview,
    cadastral_map: CadastralMapPage,
    CustomForm: SiteBaseForm,
    floorPlanList: FloorPlans,
    CheckJePlek: CheckJePlek,
}

class App extends Component {

    static contextType = LangContext;

    constructor() {
        super();
        const siteID = document.head.querySelector('meta[name="site_id"]');
        const companyId = document.head.querySelector('meta[name="company_id"]').content;
        const faceBookPixel = document.head.querySelector('meta[name="facebook_pixel"]');
        this.state = {
            addition: "",
            address: "",
            title: "",
            availability: '',
            city: "",
            hidden_address: false,
            collapseMenu: true,
            customerAddress: "",
            customerEmail: "",
            customerName: "",
            customerPhone: "",
            customerWebsite: "",
            customSiteWidget: null,
            error: {error: null},
            faceBookPixel: (faceBookPixel) ? faceBookPixel.content : null,
            fallbackBackgroundImage: {url: '', url_md: ''},
            favicon: "",
            footerHtmlText: "",
            images: [],
            isMobile: parseInt(document.head.querySelector('meta[name="mobile-check"]').content),
            isTiara: document.head.querySelector('meta[name="is-tiara"]').content,
            lang: document.documentElement.lang,
            langs: [],
            latLng: '',
            legacy360Photos: false,
            logo: "",
            logo_mobile: "",
            menuFooterIcons: [],
            number: "",
            online_bidding: "",
            openHuisBanner: null,
            pageKenmerkenContent: '',
            pageOmschrijvingContent: '',
            pages: [],
            restrictedContent: true,
            siteComponents: [],
            siteID: siteID.content,
            siteName: document.head.querySelector('meta[name="site-name"]').content,
            sitePrefix: (window.location.hostname === document.head.querySelector('meta[name="site-name"]').content) ? '/' : '/site/' + siteID.content + '/',
            size: '',
            street: "",
            zipcode: "",
            window_height: 0,
            window_width: 0,
            property_value_report: 0,
            customBiddingFormText: null,
            theme: document.head.querySelector('meta[name="site-theme"]').content,
        };
        const csrf = document.head.querySelector('meta[name="csrf-token"]');

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf.content;
        axios.defaults.headers.common['X-localization'] = document.documentElement.lang;

        this.getSitePages = this.getSitePages.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.switchLang = this.switchLang.bind(this);
        this.togglePropValRep = this.togglePropValRep.bind(this);
        this.getSiteContent = this.getSiteContent.bind(this);

    }

    componentDidCatch(error, errorInfo) {
        this.setState({error});
        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
    }

    componentDidMount() {
        ReactGA.initialize([
            {trackingId: document.head.querySelector('meta[name="analytics"]').content}
        ]);
        if (process.env.NODE_ENV === 'production') {
            if (this.state.faceBookPixel) {
                ReactPixel.init(this.state.faceBookPixel);
                ReactPixel.pageView();
            }

            this.trackPage(this.props.location.pathname);
        }
        this.getSiteContent();
    }

    getSiteContent() {
        axios.get('/api/site/' + this.state.siteID + '/data')
            .then((response) => {
                this.setState(
                    response.data
                );
            }).then((response) => {
            if (isEmpty(this.state.pageOmschrijvingContent)) {
                // add a loading screen when all is received from the axios show the page

                // Set an endpoint for details. Funda scraper returns just the HTML,
                // Tiara returns a JSON that we need to parse inside the component.
                axios.all([
                    axios.get('/api/site/' + this.state.siteID + '/images'),
                    axios.get('/api/site/' + this.state.siteID + '/details'),
                    axios.get('/api/site/' + this.state.siteID + '/description'),
                ]).then(axios.spread((imagesRes, detailsRes, descriptionRes, formRes) => {
                    if (Array.isArray(imagesRes.data)) {
                        //failsafe if the images are in an object

                        this.setState(
                            {
                                fallbackBackgroundImage: imagesRes.data[0] ? imagesRes.data[0] : null,
                                images: imagesRes.data,
                                pageKenmerkenContent: detailsRes.data,
                                pageOmschrijvingContent: descriptionRes.data,
                            }
                        );
                    } else {
                        this.setState(
                            {
                                pageKenmerkenContent: detailsRes.data,
                                pageOmschrijvingContent: descriptionRes.data,
                            }
                        );
                    }

                })).catch((error) => {
                    // Handle scenario when no Tiara data can be retrieved
                    this.setState(
                        {
                            images: [],
                        }
                    );
                });
            }
        }).catch((error) => {

        });
    }

    trackPage = (page) => {
        if (process.env.NODE_ENV === 'production') {
            ReactGA.send({
                hitType: "pageview",
                page: this.state.siteName + '/' + page
            });
        }

        post('analytics', {
            'c_id': document.head.querySelector('meta[name="company_id"]').content,
            's_id': document.head.querySelector('meta[name="site_id"]').content,
            'event_name': 'page_view',
            'event_value': page,
        })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //google analytics check if page did change
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.trackPage(this.props.location.pathname, this.props.company_id, this.props.siteID);

            if (this.state.faceBookPixel) {
                ReactPixel.pageView();
            }
        }
    }

    switchLang(e, locale) {
        this.context.lang.setLocale(locale);
        axios.defaults.headers.common['X-localization'] = locale;
        document.documentElement.setAttribute('lang', locale);
        this.setState({
            pages: [],
            lang: locale,
            pageOmschrijvingContent: '',
        });

        this.getSiteContent();
        this.props.history.push(this.state.sitePrefix);
    }

    toggleMenu(dir) {

        if (dir === 'close') {
            if (this.state.collapseMenu !== false) {
                this.setState(
                    {collapseMenu: false}
                );
            }
        } else if (dir === 'open') {
            if (this.state.collapseMenu !== true) {
                this.setState(
                    {collapseMenu: true}
                );
            }
        } else {
            this.setState(
                {collapseMenu: !this.state.collapseMenu}
            );
        }
    }

    getSitePages() {
        axios.get('/api/site/' + this.state.siteID + '/data')
            .then((response) => {
                this.setState(
                    {
                        pages: response.data.pages,
                        availability: response.data.availability,
                        customSiteWidget: response.data.customSiteWidget,
                        footerHtmlText: response.data.footerHtmlText,
                        terms: response.data.terms,
                    }
                );
            }).catch((error) => {
        })
    }

    togglePropValRep() {
        this.setState(
            {property_value_report: 0}
        );
    }

    render() {
        const sitePrefix = this.state.sitePrefix;
        let lang = this.context.lang;
        let self = this;

        let pathNames = (this.props.location.pathname).split("/");
        let logoLink = sitePrefix;
        if (logoLink.substring(logoLink.length - 1) == "/") {
            logoLink = logoLink.substring(0, logoLink.length - 1);
        }

        const logoTextTopFontSize = {
            fontSize: getMenuFontSize(this.state.address)
        };

        const logoTextBottomFontSize = {
            fontSize: getMenuFontSize(this.state.city)
        };

        if (this.state.theme !== 'light' && this.state.theme !== 'era') {

            return (
                <div className="application">
                    <Helmet>
                        <link rel="icon" href={this.state.favicon}/>
                        <link rel="apple-touch-icon" href={this.state.favicon}/>
                        <link rel="apple-touch-icon" sizes="76x76" href={this.state.favicon}/>
                        <link rel="apple-touch-icon" sizes="120x120" href={this.state.favicon}/>
                        <link rel="apple-touch-icon" sizes="152x152" href={this.state.favicon}/>
                        <link rel="shortcut icon" href={this.state.favicon}/>
                    </Helmet>

                    <div className="container">

                        {this.state.langs.length > 1 && <div className="language_container">
                            <UncontrolledButtonDropdown>
                                <DropdownToggle caret className={'btn-sm btn-primary'}>
                                    <img src={`/images/${this.state.lang.slice(0, 2)}.png`} width="32px"/> <span
                                    className={'d-none d-md-inline'}>{lang.get(`sites.language_${this.state.lang}`)}</span>
                                </DropdownToggle>
                                <DropdownMenu className="language_switcher">
                                    {this.state.langs.map((language, index) => {
                                        let flag = `/images/${language.slice(0, 2)}.png`;
                                        let divider = (this.state.langs.length !== index ?
                                            <DropdownItem divider/> : '');

                                        if (this.state.lang !== language) {

                                            return <React.Fragment key={`${language}-${index}`}><DropdownItem
                                                key={language + index}
                                                onClick={(e) => self.switchLang(e, language.slice(0, 2))}><img
                                                src={flag} width="31px"/> <span
                                                className={'d-none d-md-inline'}>{lang.get(`sites.language_${language}`)}</span></DropdownItem>{divider}
                                            </React.Fragment>

                                        }

                                    })}
                                </DropdownMenu>
                            </UncontrolledButtonDropdown>
                        </div>}

                        <div className={"row row-flex mx-auto"} style={{zIndex: '0'}}>

                            <div className="col left main-column-left" style={{zIndex: '1'}}>

                                <div className="logo d-none d-lg-block">
                                    <Link to={logoLink}>
                                        <div className="logo-texttop text-center"
                                             style={logoTextTopFontSize}>{this.state.address}</div>
                                        <div className="logo-textbottom text-center"
                                             style={logoTextBottomFontSize}>{this.state.city}</div>
                                        <img className="logo-img mx-auto d-block" src={this.state.logo}/>
                                    </Link>
                                </div>

                                <Menu sitePrefix={this.state.sitePrefix}
                                      pages={this.state.pages}
                                      mobileLogo={this.state.logo_mobile}
                                      toggleMenu={this.toggleMenu}
                                      menuCollapsed={this.state.collapseMenu}
                                      purchasePrice={this.state.purchasePrice}
                                      status={this.state.availability}
                                      currentPath={pathNames[pathNames.length - 1]}
                                      isMobile={this.state.isMobile}
                                      icons={this.state.menuFooterIcons}
                                      openHuisBanner={this.state.openHuisBanner}
                                      customSiteWidget={this.state.customSiteWidget}
                                />

                            </div>

                            <div className={"col right sm-px-2 main-column-right"} style={{zIndex: '0'}}>
                                <div className="d-block d-lg-none" style={{height: '60px'}}></div>
                                <RouteRenderer
                                    pages={this.state.pages}
                                    history={this.props.history}
                                    sitePrefix={this.state.sitePrefix}
                                    legacy360Photos={this.state.legacy360Photos}
                                    state={this.state}
                                    getSitePages={this.getSitePages}
                                    togglePropValRep={this.togglePropValRep}
                                    toggleMenu={this.toggleMenu}
                                />
                            </div>

                        </div>

                    </div>
                </div>
            )

        }

        return (
            <div className="application">
                <Helmet>
                    <link rel="icon" href={this.state.favicon}/>
                    <link rel="apple-touch-icon" href={this.state.favicon}/>
                    <link rel="apple-touch-icon" sizes="76x76" href={this.state.favicon}/>
                    <link rel="apple-touch-icon" sizes="120x120" href={this.state.favicon}/>
                    <link rel="apple-touch-icon" sizes="152x152" href={this.state.favicon}/>
                    <link rel="shortcut icon" href={this.state.favicon}/>
                </Helmet>

                <HorizontalMenu sitePrefix={this.state.sitePrefix}
                                pages={this.state.pages}
                                logo={this.state.logo}
                                mobileLogo={this.state.logo_mobile}
                                toggleMenu={this.toggleMenu}
                                menuCollapsed={this.state.collapseMenu}
                                purchasePrice={this.state.purchasePrice}
                                status={this.state.availability}
                                currentPath={pathNames[pathNames.length - 1]}
                                isMobile={this.state.isMobile}
                                icons={this.state.menuFooterIcons}
                                openHuisBanner={this.state.openHuisBanner}
                                customSiteWidget={this.state.customSiteWidget}
                                theme={this.state.theme}
                                street={this.state.street}
                                number={this.state.number}
                                addition={this.state.addition}
                                city={this.state.city}
                                bidding={this.state.online_bidding}
                                siteID={this.state.siteID}
                                online_bidding={this.state.online_bidding}
                                country={this.state.country}
                                biddingForms={this.state.biddingForms}
                                terms={this.state.terms}
                                renderModal={this.state.renderModal}
                                customFormText={this.state.customFormText}
                                customBiddingFormText={this.state.customBiddingFormText}

                />

                {this.state.langs.length > 1 && <div className="language_container">
                    <UncontrolledButtonDropdown>
                        <DropdownToggle
                            tag="span"
                            className="mt-1"
                            data-toggle="dropdown">
                            <img src={`/images/${this.state.lang.slice(0, 2)}.png`} width="32px"/>
                        </DropdownToggle>
                        <DropdownMenu className="language_switcher">
                            {this.state.langs.map((language, index) => {
                                let flag = `/images/${language.slice(0, 2)}.png`;
                                let divider = (this.state.langs.length !== index ? <DropdownItem divider/> : '');

                                if (this.state.lang !== language) {

                                    return <React.Fragment key={`${language}-${index}`}><DropdownItem
                                        key={language + index}
                                        onClick={(e) => self.switchLang(e, language.slice(0, 2))}><img
                                        src={flag} width="32px"/> <span
                                        className={'d-none d-md-inline'}>{lang.get(`sites.language_${language}`)}</span></DropdownItem>{divider}
                                    </React.Fragment>

                                }

                            })}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </div>}

                <div style={{zIndex: '0'}}>
                    <div className={"col-12 col-md-10 col-lg-8 col-xl-7 m-auto p-0 default-page-container"}>
                        <RouteRenderer
                            pages={this.state.pages}
                            history={this.props.history}
                            sitePrefix={this.state.sitePrefix}
                            legacy360Photos={this.state.legacy360Photos}
                            state={this.state}
                            getSitePages={this.getSitePages}
                            togglePropValRep={this.togglePropValRep}
                            toggleMenu={this.toggleMenu}
                        />
                    </div>
                </div>
            </div>
        )

    }
}

export default withRouter(App);


const RouteRenderer = ({pages, sitePrefix, legacy360Photos, getSitePages, toggleMenu, togglePropValRep, state, history}) => {

    const {lang} = useContext(LangContext);

    return (
        <Switch>
            {
                pages.map((page, key) => {
                    //google analytics send current location
                    if (typeof page.type != 'undefined' && page.type != 'Dropdown' && page.type != '') {
                        let MyComponent = Modules[page.type];
                        let background_video = '';
                        if (page.type == 'FullScreenVideo') {
                            background_video = page.background_image_id;
                        }
                        if (!(page.type in Modules)) {
                            MyComponent = Custom;
                        }

                        if (legacy360Photos) {
                            if (page.type === 'Photos360') {
                                MyComponent = Photos360Legacy;
                            }
                        }

                        if (page.type === 'TiaraKenmerken' || page.type === 'FundaKenmerken') {
                            MyComponent = Kenmerken;
                        }

                        if (page.type === 'TiaraOmschrijving' || page.type === 'FundaOmschrijving') {
                            MyComponent = Omschrijving;
                        }
                        if (page.type === 'bidding') {
                            return <Route key={key}
                                          path={sitePrefix + page.slug}
                                          render={() => <FullScreenPhotos
                                              {...state}
                                              toggleMenu={toggleMenu}
                                              pageType={'Home'}
                                              biddingForms={BiddingForms}
                                              renderModal={true}
                                              togglePropValRep={togglePropValRep}
                                          />}/>
                        }
                        return <Route key={key}
                                      path={sitePrefix + page.slug}
                                      render={() =>
                                          <MyComponent pageId={page.ID}
                                                       page={page}
                                                       history={history}
                                                       background_video={background_video}
                                                       getSitePages={getSitePages}
                                                       page_content={page.page_content}
                                                       toggleMenu={toggleMenu}
                                                       togglePropValRep={togglePropValRep}
                                                       biddingForms={BiddingForms}
                                                       {...state}
                                          />
                                      }
                        />
                    }
                })
            }
            <Route key={9997} path={sitePrefix + slugify(lang.get('sites.bid'))}>
                <FullScreenPhotos
                    {...state}
                    toggleMenu={toggleMenu}
                    pageType={'Home'}
                    biddingForms={BiddingForms}
                    renderModal={true}
                    togglePropValRep={togglePropValRep}
                />
            </Route>
            {state.property_value_report === 1 &&
                <Route key={9998} path={sitePrefix + lang.get('sites.house_value').replace(' ', '-').toLowerCase()}>
                    <WoningWaarde
                        getSitePages={getSitePages}
                        toggleMenu={toggleMenu}
                        {...state}
                    />
                </Route>
            }
            {/* the default route for slash */}
            <Route key={9999} component={() => (<Route key={0} render={() =>
                <FullScreenPhotos
                    {...state}
                    toggleMenu={toggleMenu}
                    pageType={'404'}
                    biddingForms={BiddingForms}
                    renderModal={false}
                    togglePropValRep={togglePropValRep}
                />}
            />)
            }/>
        </Switch>
    )
}
